import React from 'react';
import { Box, Typography } from '@mui/material';

const ACCENT = '#2C3E2D';
const INK = '#0C0C0B';
const MUTED = '#74706B';
const RULE = '#E4DFD9';
const SERIF = '"Playfair Display", Georgia, serif';
const SANS = '"DM Sans", system-ui, sans-serif';

export interface StatCardProps {
  label: string;
  value: string | number;
  sub?: string;
  highlight?: boolean;
  warn?: boolean;
  accentColor?: string;
}

export default function StatCard({
  label,
  value,
  sub,
  highlight,
  warn,
  accentColor = ACCENT,
}: StatCardProps) {
  const valueColor = warn ? '#BF360C' : highlight ? accentColor : INK;
  return (
    <Box
      sx={{
        p: '10px 14px',
        bgcolor: '#FFFFFF',
        border: `1px solid ${RULE}`,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 2,
          bgcolor: warn ? '#BF360C' : accentColor,
          transform: highlight || warn ? 'scaleX(1)' : 'scaleX(0)',
          transformOrigin: 'left',
          transition: 'transform 0.3s',
        }}
      />
      <Typography
        sx={{
          fontSize: '0.58rem',
          fontWeight: 600,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: MUTED,
          mb: '3px',
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: '1.15rem',
          fontWeight: 700,
          color: valueColor,
          lineHeight: 1,
          mb: '2px',
        }}
      >
        {value}
      </Typography>
      {sub && <Typography sx={{ fontSize: '0.56rem', color: MUTED }}>{sub}</Typography>}
    </Box>
  );
}
